import { collection, query, where, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase";

const formatDateToISO = (val) => {
  if (!val) return '';
  if (val.toDate) return val.toDate().toISOString().slice(0, 16);
  if (val instanceof Date) return val.toISOString().slice(0, 16);
  const d = new Date(val);
  if (!isNaN(d.getTime())) return d.toISOString().slice(0, 16);
  return '';
};

export const loadCurrentNotifications = async () => {
  try {
    const now = new Date();
    const notificationsQuery = query(
      collection(db, "notifications"),
      where("beginDate", "<=", now),
      where("endDate", ">=", now)
    );
    const querySnapshot = await getDocs(notificationsQuery);

    const notificationsData = querySnapshot.docs.map(doc => {
      const data = doc.data();
      data.beginDate = data.beginDate.toDate();
      data.endDate = data.endDate.toDate();

      return {
        id: doc.id,
        ...data
      };
    });
    console.log("Notifications loaded successfully:", notificationsData);
    return notificationsData;

  } catch (error) {
    console.error("Error loading notifications:", error);
    return [];
  }
};

export const loadNotifications = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "notifications"));
    
    const notificationsData = querySnapshot.docs.map(doc => {
      const data = doc.data();
      
      // Handle beginDate
      if (data.beginDate?.toDate) {
        data.beginDate = data.beginDate.toDate();
      } else if (data.beginDate) {
        data.beginDate = new Date(data.beginDate);
      }

      // Handle endDate
      if (data.endDate?.toDate) {
        data.endDate = data.endDate.toDate();
      } else if (data.endDate) {
        data.endDate = new Date(data.endDate);
      }

      return {
        id: doc.id,
        ...data
      };
    });
    console.log("Notifications loaded successfully:", notificationsData);
    return notificationsData;

  } catch (error) {
    console.error("Error loading notifications:", error);
    return [];
  }
}

// Updated addNotification function using addDoc
export const addNotification = async (notificationData) => {
  try {
    const docRef = await addDoc(collection(db, "notifications"), notificationData);
    return { id: docRef.id, ...notificationData };
  } catch (error) {
    console.error("Error adding notification:", error);
    throw error;
  }
};

// Updated loadNotification function using getDoc
export const loadNotification = async (nid) => {
  try {
    const docRef = doc(db, "notifications", nid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        id: docSnap.id,
        ...data,
        beginDate: formatDateToISO(data.beginDate),
        endDate: formatDateToISO(data.endDate)
      };
    } else {
      throw new Error("No such notification!");
    }
  } catch (error) {
    console.error("Error loading notification:", error);
    throw error;
  }
};

export const updateNotification = async (notificationData) => {
  try {

    // Update the beginDate and endDate fields to Firestore Timestamp objects
    if (notificationData.beginDate) {
      notificationData.beginDate = new Date(notificationData.beginDate);
    }
    if (notificationData.endDate) {
      notificationData.endDate = new Date(notificationData.endDate);
    }

    await updateDoc(doc(db, "notifications", notificationData.id), notificationData);
    return true;
  } catch (error) {
    console.error("Error updating notification:", error);
    throw error;
  }
};

export const deleteNotification = async (notificationId) => {
  try {
    await deleteDoc(doc(db, "notifications", notificationId));
    return true;
  } catch (error) {
    console.error("Error deleting notification:", error);
    throw error;
  }
};
